import welcome from "@/assets/images/welcome01.png";
import "./index.less";

const PCH5 = () => {
	return (
		<div style={{ width: "100vw", height: "100vh", overflowY: "hidden" }}>
			<img
				style={{ width: "100vw", height: "calc(100vh - 100px)" }}
				src="https://dan-cn-dbc-b2b-pic.oss-cn-shanghai.aliyuncs.com/uat-b2b-pic/platform/1882357239401066496.jpg"
				alt="welcome"
			/>
			<div style={{ textAlign: "center", paddingBottom: 10, color: "gray" }}>
				Copyright © 2025 <span style={{ color: "blue" }}>lianwei.xyz</span> 版权所有
			</div>
			<div style={{ textAlign: "center", color: "blue" }}>
				<a href="https://beian.miit.gov.cn" style={{ textAlign: "center", color: "blue", textDecoration: "none" }}>
					沪ICP备10006391号-95
				</a>
			</div>
		</div>
	);
};

export default PCH5;
